// <s-filter-tabs> — filters [data-filter-item] elements (space-separated collection handles) by [data-filter-value] buttons.
class SFilterTabs extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll("[data-filter-value]")];
    this.items = [...this.querySelectorAll("[data-filter-item]")];
    this.empty = this.querySelector("[data-filter-empty]");
    this.buttons.forEach((button) => {
      button.addEventListener("click", () => this.select(button));
    });
  }

  select(active) {
    const value = active.dataset.filterValue;
    let shown = 0;
    this.buttons.forEach((button) => {
      button.setAttribute("aria-pressed", String(button === active));
    });
    this.items.forEach((item) => {
      const handles = item.dataset.filterItem.split(" ");
      const match = value === "all" || handles.includes(value);
      item.hidden = !match;
      if (match) shown += 1;
    });
    if (this.empty) this.empty.hidden = shown > 0;
  }
}

if (!customElements.get("s-filter-tabs")) {
  customElements.define("s-filter-tabs", SFilterTabs);
}
